module.exports = __webpack_public_path__ + "img/deletingAccount.56ccadfd.svg";